import StoredLayout from '../../layouts/StoredLayout'
import Installation from './Installation'
export default StoredLayout(Installation)



// WEBPACK FOOTER //
// ./src/documentation/installation/index.js